




































import Vue from 'vue'
import Component from 'vue-class-component'
import {
  EditablePostForm,
  editablePostFormMapping,
} from '@/business/post/components/editable-post/editable-post-form-mapping'
import { Hooks } from '@/shared/interfaces/hooks'
import { TypedForm } from '@/shared/forms/typed-form'
import { PostUpdate } from '@/business/post/models/post-update'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { Prop } from 'vue-property-decorator'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import { Post } from '@/business/post/models/post'
import { Injector } from '@/config/dependency-injection'
import { NotificationService } from '@/shared/services/notification-service'
import RespondecoPost from '@/business/post/components/post/post.vue'
import PostHeader from '@/business/post/components/post/post-header.vue'
import PostReplies from '@/business/post/components/post/post-replies.vue'
import PostContainer from '@/business/post/components/post/post-container.vue'

@Component({
  name: 'respondeco-editable-post',
  components: {
    PostContainer,
    PostReplies,
    PostHeader,
    RespondecoPost,
    RespondecoEditor,
    UnifyButton,
    RespondecoValidationFeedback,
    UnifyFormInput,
    RespondecoForm,
  },
})
export default class RespondecoEditablePost extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Boolean,
  })
  public pending!: boolean

  @Prop({
    type: Object,
  })
  public post?: Post

  @Prop({
    default: () => false,
    type: Boolean,
  })
  public startCollapsed!: boolean

  @Prop({
    required: true,
    type: Function,
  })
  public readonly submit!: (post: PostUpdate) => Promise<Post>

  public collapsed: boolean = false

  public form!: TypedForm<PostUpdate, EditablePostForm>

  private readonly notificationService = Injector.get(NotificationService)

  public mounted() {
    this.collapsed = this.startCollapsed === true

    this.form.reset({
      content: '',
    })

    if (this.post !== undefined) {
      this.form.deserialize({
        content: this.post.content,
        title: this.post.title,
      })
    }
  }

  public data(): any {
    return {
      form: new TypedForm(editablePostFormMapping(), this),
    }
  }

  public validations() {
    return this.form.validations()
  }

  public handleCancel(): void {
    this.$emit('cancel')

    if (this.post === undefined) {
      this.toggle()
    }
  }

  public handleSubmit(): void {
    const post = this.form.serialize(this.post)

    this.submit(post)
      .then(() => {
        this.form.reset({
          content: '',
        })

        if (this.post === undefined) {
          this.toggle()
        }
      })
      .catch(error => {
        this.notificationService.error(error)
      })
  }

  public toggle(): void {
    this.collapsed = !this.collapsed
  }
}
